import { helper as buildHelper } from '@ember/component/helper';
import Moment from 'moment';

/**
 * Take the passed in date, and convert it to UTC.
 *
 * @param {Array} params
 * @return {Moment}
 */
export function dateAndTimeToUtcDate(params/*, hash*/) {
  let date = params[0];
  return Moment(date).utc();
}

export default buildHelper(dateAndTimeToUtcDate);
